import React from "react";
import Slider from "react-slick";

const VehicleSlider = () => {
  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 800,
    autoplay: true,
    autoplaySpeed: 2500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
const vehicles = [
  {
    name: "Hyundai Aura",
    image: "/images/gallery/aura.jpg",
  },
  {
    name: "Maruti Suzuki Dzire",
    image: "/images/gallery/dzire.jpg",
  },
  {
    name: "Maruti Suzuki Ertiga",
    image: "/images/gallery/ertiga.jpg",
  },
  {
    name: "Toyota Innova Crysta",
    image: "/images/gallery/crysta.jpg",
  },
  {
    name: "Force Urbania (17 Seater)",
    image: "/images/gallery/urbania.jpg",
  },
  {
    name: "Tempo Traveller (20 Seater)",
    image: "/images/gallery/20-seater-tempo-traveller.jpg",
  },
];

  return (
    <section className="py-2 bg-white">
      <div className="container">
        <Slider {...settings}>
          {vehicles.map((item, index) => (
            <div key={index} className="px-3">
              <div className="vehicle-card">
                <div className="vehicle-image">
                  <img
                    src={item.image}
                    alt={item.name}
                    className="img-fluid"
                  />
                </div>
                <div className="vehicle-title">
                  {item.name}
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default VehicleSlider;
